<template>
  <div>
    <v-skeleton-loader
      v-if="firstLoad"
      type="card-heading, list-item@5"
      height="380"
      class="mt-5"
    >
    </v-skeleton-loader>
    <v-card v-show="!firstLoad">
      <v-card-title> Ajouter un utilisateur </v-card-title>

      <v-card-subtitle> Editer ses informations personnelles </v-card-subtitle>

      <validation-observer ref="userObserver" v-slot="{ invalid }">
        <form @submit.prevent="submitMyProfile">
          <v-card-text>
            <input type="hidden" name="id" />

            <validation-provider
              v-slot="{ errors }"
              vid="firstName"
              name="prénom"
              rules="required|max:35"
            >
              <v-text-field
                v-model="firstName"
                :counter="35"
                :error-messages="errors"
                label="Prénom"
                required
              ></v-text-field>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              vid="lastName"
              name="nom"
              rules="required|max:35"
            >
              <v-text-field
                v-model="lastName"
                :counter="35"
                :error-messages="errors"
                label="Nom"
                required
              ></v-text-field>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              vid="email"
              name="email"
              rules="required|max:50|email"
            >
              <v-text-field
                v-model="email"
                :error-messages="errors"
                label="Email"
                required
              ></v-text-field>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              vid="broker"
              name="courtier"
              rules="required"
            >
              <v-select
                :items="brokerList"
                v-model="broker"
                :error-messages="errors"
                label="Courtiers"
                outlined
                hide-details
                hide-selected
                clearable
                item-text="name"
                item-value="id"
              ></v-select>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              vid="role"
              name="rôle"
              rules="required"
            >
              <v-select
                :items="roles"
                v-model="role"
                :error-messages="errors"
                label="Rôle"
                outlined
                hide-details
                hide-selected
                clearable
                item-text="name"
                item-value="id"
                class="mt-5"
              ></v-select>
            </validation-provider>
          </v-card-text>

          <v-card-actions class="text-right">
            <v-btn
              :loading="loadingUpdateMyprofile"
              color="button"
              class="button_color--text"
              type="submit"
              :disabled="invalid"
            >
              enregistrer
            </v-btn>
            <v-spacer />
            <v-btn color="button" class="button_color--text" to="/user/search">
              Annuler
            </v-btn>
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>

    <v-snackbar
      v-model="snackbar"
      :color="message.type"
      :multi-line="true"
      timeout="3000"
    >
      {{ message.message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="button_color--text"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped></style>

<script>
// import { required, confirmed, digits, email, max, min, regex } from 'vee-validate/dist/rules'
import { required, confirmed, email, max, min } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import { localize } from "vee-validate";
import fr from "vee-validate/dist/locale/fr.json";
localize("fr", fr);

setInteractionMode("eager");

extend("required", {
  ...required,
  // message: '{_field_} can not be empty',
});

extend("confirmed", {
  ...confirmed,
  // message: '{_field_} not identical',
});

extend("email", {
  ...email,
  // message: 'Email must be valid',
});

extend("max", {
  ...max,
  // message: '{_field_} may not be greater than {length} characters',
});

extend("min", {
  ...min,
  // message: '{_field_} may not be smaller than {length} characters',
});

// create custom error message for custom rule
var errorMessage =
  "doit contenir au minimum 8 caractères. Avec au moins un caractère spécial (#, !, @, $, %, ^, *, -), une minuscule, une majuscule et un chiffre";
// create custom rule
extend("customPassword", {
  message: (field) => "Le mot de passe " + errorMessage,
  validate: (value) => {
    var notTheseChars = /["'?&/<>\s]/;
    var mustContainTheseChars =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@$%^*-]).{8,}$/;
    var containsForbiddenChars = notTheseChars.test(value);
    var containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars && !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        errorMessage =
          'contient des caractères interdits:  " ' +
          " ' ? & / < > ou des espaces";
      } else {
        errorMessage =
          "doit contenir au minimum 8 caractères. Avec au moins un caractère spécial (#, !, @, $, %, ^, *, -), une minuscule, une majuscule et un chiffre";
      }
      return false;
    }
  },
});

import axios from "axios";

export default {
  name: "userAdd",

  components: {
    ValidationProvider,
    ValidationObserver,
  },

  data: () => ({
    firstLoad: false,

    loadingUpdateMyprofile: false,
    loadingUpdateMyPassword: false,

    snackbar: false,
    success: false,
    message: [],
    errors: [],

    id: "",
    firstName: "",
    lastName: "",
    email: "",
    roles: [],
    role: null,
    brokerList: [],
    broker: "",
  }),
  created() {},
  mounted() {
    this.getBrokerList();
    this.getRoles();
  },
  computed: {},
  methods: {
    getBrokerList() {
      axios
        .post("/api/broker/search", {
          id: "",
          firstName: "",
          lastName: "",
          email: "",
          isEnabled: true,
          pageSize: 0,
          firstPage: 0,
          sortField: "firstName",
          sortOrder: "ASC",
        })
        .then((brokerList) => {
          this.brokerList = brokerList.data.brokerList;
        });
    },
    getRoles() {
      axios
        .post("/api/broker/roles/get", {})
        .then((response) => {
          let success = response.data.success;
          let message = response.data.message;
          let errors = response.data.errors;
          this.roles = response.data;
          resolve({
            success,
            message,
            errors,
          });
        })
        .catch((error) => {});
    },
    submitMyProfile() {
      this.loadingUpdateMyprofile = true;

      this.updateMyProfile().then((data) => {
        if (this.firstLoad) this.firstLoad = false;
        this.success = data.success;
        this.message = data.message;

        this.$refs.userObserver.setErrors(data.errors);

        this.loadingUpdateMyprofile = false;
        this.snackbar = true;

        setTimeout(() => this.$router.push("/user/search/"), 3000);
      });
    },
    updateMyProfile() {
      this.$refs.userObserver.validate();

      return new Promise((resolve, reject) => {
        axios
          .post("/api/broker/user/add", {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            brokerId: this.broker,
            role: this.role,
          })
          .then((response) => {
            // Success 🎉
            //console.log(response.data);
            let success = response.data.success;
            let message = response.data.message;
            let errors = response.data.errors;
            resolve({
              success,
              message,
              errors,
            });
          })
          .catch((error) => {
            // Error 😨
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              console.log("error.response");
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log("error.request");
              console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              console.log("Error");
              console.log("Error", error.message);
            }
            console.log("error.config");
            console.log(error.config);
          });
      });
    },
  },
  watch: {},
};
</script>
